import { Close } from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import AutoComplete, { AutoCompleteOption } from "../../../common/AutoComplete";
import Ellipsis from "../../../common/Ellipsis";
import { nameof } from "../../../common/ObjectUtils";
import { EquipmentKitRequests, EquipmentKitService } from "../EquipmentKitService";
import { useEquipmentKitTabTranslation } from "../Utils";

type Props = {
  tenant:string;
  isOpen: boolean;
  onClose: () => void;
  equipmentKitId?: number;
  onUpdateDatasource?: () => void;
  
}

const AddEquipment = (props: Props) => {
  const { dispatchGlobalData } = useContext(GlobalContext);

  const [equipments, setEquipments] = useState<AutoCompleteOption[]>([]);

  const { t } = useEquipmentKitTabTranslation();

  const handleSubmit = (data: any) => {
    if (props.equipmentKitId) {
      EquipmentKitService.update.addEquipment(props.tenant,props.equipmentKitId, data).then(
        response => {
          props.onClose();
          formik.resetForm();

          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("addEquipment.succesfull"),
                type: snackbarTypes.success,
                show: true,
                autoClose: true,
              },
            },
          });

          props.onUpdateDatasource && props.onUpdateDatasource();
        },
        () => {
          props.onClose();
          formik.resetForm();

          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("addEquipment.error"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        }
      )
    }
  }

  const formik = useFormik<EquipmentKitRequests.Update>({ initialValues: {
    code: "",
    descr: "",
    equipmentsId: [],
  }, onSubmit: handleSubmit });

  useEffect(() => {
    if (props.isOpen) {
      EquipmentKitService.get.valids(props.tenant).then(
        response => {
          setEquipments(response.map(res => ({
            label: res.descr,
            value: res.id
          })));
        }
      );
    }
  }, [props.isOpen]);

  useEffect(() => {
    if (props.isOpen && props.equipmentKitId) {
      EquipmentKitService.get.byId(props.tenant,props.equipmentKitId).then(
        response => {
          formik.setValues({
            code: response.code,
            descr: response.descr,
            equipmentsId: response.equipments.map(eq => eq.id),
          });
        }
      )
    }
  }, [props.isOpen, props.equipmentKitId]);

  return (
    <Mui.Dialog open={props.isOpen} onClose={props.onClose} fullWidth={true} maxWidth="sm">
      <Mui.DialogTitle position="relative">
        <Mui.Grid container alignItems="center">
          <Mui.Grid item xs={11}>
            <Mui.Stack direction="row" flexWrap="wrap">
              <Mui.Typography fontSize="18px" fontWeight={400} paddingRight="6px">{t("addEquipment.title")}</Mui.Typography>
                
              <Mui.Tooltip title={`${formik.values.code} - ${formik.values.descr}`}>
                <Ellipsis>
                  <Mui.Typography variant="bodyLarge">{`${formik.values.code} - ${formik.values.descr}`}</Mui.Typography>
                </Ellipsis>
              </Mui.Tooltip>
            </Mui.Stack>
          </Mui.Grid>

          <Mui.Grid item xs={1} marginLeft="auto">
            <Mui.IconButton onClick={props.onClose}>
              <Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>

      <Mui.DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Mui.Grid container>
            <Mui.Grid item xs={6}>
              <AutoComplete
                multiple={true}
                options={equipments}
                label={t("addEquipment.fields.equipment")}
                value={formik.values.equipmentsId}
                onChange={(value) => formik.setFieldValue(nameof<EquipmentKitRequests.Update>("equipmentsId"), value)}
                fullWidth={true}
              />
            </Mui.Grid>
          </Mui.Grid>
        </form>
      </Mui.DialogContent>

      <Mui.DialogActions>
        <Mui.Button onClick={props.onClose} variant="outlined">
          {t("addEquipment.actions.cancel")}
        </Mui.Button>
        <Mui.Button onClick={formik.submitForm}>
          {t("addEquipment.actions.save")}
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  )
}

export default AddEquipment